<template>
<div v-if="!isMobile" class="head_container" @click="onHeaderContainerClick">
        <div id="wiki_file_ino_popup"></div>
        <div class="foldBtnContainer" v-if="!isKBDirExpand">
            <a-tooltip :content="$t('展开')" popup-container="#main_view" content-class="custom_tooltip_css" arrow-class="custom_tooltip_css_arrow" :popup-visible="isDirExpandTipShow">
                <svg-icon v-if="!isKBDirExpand" class="kb_dir_expand_icon" name="dir-dir_expand" v-on:mouseenter="isDirExpandTipShow = true" v-on:mouseleave="isDirExpandTipShow = false" @click="expandDir"></svg-icon>
            </a-tooltip>
        </div>
        <div v-if="isSourceFromHome" class="kb_name_container">
            <RecentFileEntrance :isSourceHome="isSourceFromHome"></RecentFileEntrance>
        </div>
        <div v-if="routeItems.length > 0" class="title_container">
            <!-- input -->
            <div :class="[
                    'a_input_container',
                    'align-items-center',
                    isSourceFromHome ? 'a_input_container_home' : ''
                ]">
                <!-- @input="inputAction" -->
                <a-input :readonly="authIsReadonly" :placeholder="$t('请输入标题')" @input="onInputingAction" @change="inputAction" @drop="inputDrop" :max-length="100" v-model="this.$store.state.hocuspocusModule.documentTitle" :style="{
                        fontSize: '14px',
                        width: `${_title_input_width}px`
                    }"></a-input>
                <div v-if="isTemplate" :class="[
                        'templateMark',
                        this.wikiI18n === 'en-us' ? 'templateMark_en' : ''
                    ]">
                    <svg-icon :name="
                            this.wikiI18n === 'en-us'
                                ? 'header-template_mark_en'
                                : 'header-template_mark'
                        "></svg-icon>
                </div>
                <a-tooltip :content="starTip" popup-container="#main_view" content-class="custom_tooltip_css" arrow-class="custom_tooltip_css_arrow">
                    <div class="head_star_icon_container" @click="clickStar">
                        <svg-icon class="head_star_icon" :name="starIconName"></svg-icon>
                    </div>
                </a-tooltip>
                <AuthHead :auth="auth" v-if="auth == 'READ' || auth == 'READ_DOWNLOAD'"></AuthHead>
                <div @click="clickCheckReminder" id="check_reminder_container"></div>
            </div>
            <div v-if="!isSourceFromHome" ref="breadCrumbRef" class="bread_crumb_container">
                <img class="brand" :src="getAssetURL('dir_brand.png')"/>
                <BreadCrumb separator="/" @crumbMounted="crumbMounted">
                    <BreadcrumbItem v-for="(item, index) of showRouteItems" :key="index">
                        <a class="active" @click="gotoRoute(item)">
                            <a-trigger content-class="kb_bread_popover" arrow-class="kb_bread_arrow" position="bl" :popup-translate="[-10, 10]" v-if="item.placeholder">
                                <span @mouseover="breadMoreIconHovered = true" @mouseleave="breadMoreIconHovered = false"><svg-icon :name="breadMoreIconName"></svg-icon></span>
                                <template #content>
                                    <BreadCrumbDropList :dropList="hideRouteItems" @clickItem="gotoRoute"></BreadCrumbDropList>
                                </template>
                            </a-trigger>
                            <span v-else>{{ item.fileName }}</span>
                        </a>
                        <!--
                        <a class="default" v-else>
                            <span v-if="item.placeholder">...</span>
                            <span v-else>{{ item.fileName }}</span>
                        </a>
                        -->
                    </BreadcrumbItem>
                </BreadCrumb>
            </div>
        </div>
        <div v-if="routeItems.length <= 0" class="a_input_container align-items-center">
            <!-- @input="inputAction" -->
            <a-input :readonly="authIsReadonly" :placeholder="$t('请输入标题')" @input="onInputingAction" @change="inputAction" @drop="inputDrop" :max-length="100" v-model="this.$store.state.hocuspocusModule.documentTitle" :style="{
                    fontSize: '14px',
                    width: `${_title_input_width}px`
                }"></a-input>
            <div v-if="isTemplate" :class="[
                    'templateMark',
                    this.wikiI18n === 'en-us' ? 'templateMark_en' : ''
                ]">
                <svg-icon :name="
                        this.wikiI18n === 'en-us'
                            ? 'header-template_mark_en'
                            : 'header-template_mark'
                    "></svg-icon>
            </div>
            <a-tooltip :content="starTip" popup-container="#main_view" content-class="custom_tooltip_css" arrow-class="custom_tooltip_css_arrow">
                <div class="head_star_icon_container" @click="clickStar">
                    <svg-icon class="head_star_icon" :name="starIconName"></svg-icon>
                </div>
            </a-tooltip>

            <AuthHead :auth="auth" v-if="auth == 'READ' || auth == 'READ_DOWNLOAD'"></AuthHead>
            <div @click="clickCheckReminder" id="check_reminder_container"></div>
        </div>

        <!-- tail_container -->
        <div class="tail_container">
            <span v-if="!isSourceFromHome" v-for="(item, index) in filterAwareness" :key="index" :class="['left_8px'/*,_allAwareness.length <= 1 ? 'right_12px' : ''*/]">
                <a-avatar v-if="this.getAvatar(item.user?.avatar) === undefined" class="radius_8px" shape="square" :size="26" :style="{ backgroundColor: item.user?.color ?? '#1DADFF' }">{{ fixUsername(item.user?.name) }}</a-avatar>
                <a-tooltip v-else :content="item.user.name" popup-container="#main_view" content-class="custom_tooltip_css" arrow-class="custom_tooltip_css_arrow">
                    <a-avatar class="radius_4px" shape="square" :size="26"><img :src="this.getAvatar(item.user?.avatar)" alt=""/></a-avatar>
                </a-tooltip>
            </span>
            <!-- 更多用户头像 -->
            <a-popover v-if="_allAwareness.length > 1 && !isSourceFromHome" trigger="click" content-class="ccccccccontent">
                <div class="more_user_count">
                    <div class="number">{{ moreUserCount }}</div>
                </div>
                <template #content>
                    <div class="dropdown_container">
                        <div v-for="(item, index) in _allAwareness" :key="index" class="dropdown_item">
                            <img class="dropdown_container_img" :src="this.getAvatar(item.user?.avatar)" alt=""/>
                            <span class="dropdown_container_name">{{
                                item.user?.name
                            }}</span>
                        </div>
                    </div>
                </template>
            </a-popover>
            <div class="link_share_range_set" id="link_share_range_set" style="display: none;"></div>

            <FileShareView ref="fileShareViewRef" v-if="auth !== null" :myAuth="auth" :creator="creator" :showShare="showShare" :fileId="fileId" :fileUrl="doc_info.fileInfo.fileUrl" :userInfo="currentUserParams" :sameSpace="sameSpace" :creatorInfo="creatorInfo" :contentType="contentType" @closeShareView="handleCloseShareView" @applyAuth="changeToApplyAuthView" @updateAuthInfos="updateAuthInfos" @updateLinkShareRange="updateLinkShareRange" @onLinkRangeSetDropdownVisible="onLinkRangeSetDropdownVisible" @UpdateLinkShareRangeSet="UpdateLinkShareRangeSet">
                <template v-slot:reference>
                    <a-tooltip :content="
auth === 'ALL' ||
auth === 'WRITE' &&
creatorInfo?.userId ===
currentUserParams.userId &&
creatorInfo?.spaceId ===
currentUserParams.spaceId ? $t('权限管理') : $t('查看协作者')" popup-container="#main_view" content-class="custom_tooltip_css" arrow-class="custom_tooltip_css_arrow" :popup-visible="showShareTip" @mouseenter="sharMouseEnter" @mouseleave="showShareTip = false">
                        <div class="shareBtn" @click.prevent="
                                showShare = !showShare;
                                showShareScope = false;
                                showShareTip = false;
                            ">
                            <svg-icon name="share-share_auth_manage" style="width: 16px; height: 16px"></svg-icon>
                        </div>
                    </a-tooltip>
                </template>
            </FileShareView>

            <FileShareScopeView ref="fileShareScopeViewRef" :showShareScope="showShareScope" :fileId="fileId" :fileUrl="doc_info.fileInfo.fileUrl" :myAuth="auth" :userInfo="currentUserParams" :creatorInfo="creatorInfo" @closeShareScopeView="handleCloseShareScopeView" @pushToShareView="pushToShareView" @updateLinkShareRange="updateLinkShareRange" @onLinkRangeSetDropdownVisible="onLinkRangeSetDropdownVisible" @UpdateLinkShareRangeSet="UpdateLinkShareRangeSet">
                <template v-slot:reference>
                    <a-tooltip :content="shareAuthTip" popup-container="#main_view" content-class="custom_tooltip_css" arrow-class="custom_tooltip_css_arrow" :popup-visible="showShareScopeTip" @mouseenter="shareScopeMouseEnter" @mouseleave="showShareScopeTip = false">
                        <div class="shareBtn" @click.prevent="clickShareScope">
                            <img src="@/assets/img/share/icon_file_share.png" style="width: 16px; height: 16px"/>
                        </div>
                    </a-tooltip>
                </template>
            </FileShareScopeView>

            <div :class="[
                    'preview_or_edit_btn',
                    isSupportEdit === false ? 'preview_or_edit_btn_disable' : ''
                ]" @click="preview_or_edit_action" @mouseenter="preview_or_edit_btn_mouse_state = true" @mouseleave="preview_or_edit_btn_mouse_state = false" v-if="!authIsReadonly">
                <svg-icon style="width: 16px; height: 16px; margin-right: 5px" class="svg_icon" :name="get_preview_or_edit_btn_icon_name"></svg-icon>                {{settingsValue === 'PREVIEW' ? $t("进入编辑") : $t("进入阅读")}}            </div>

            <a-divider direction="vertical"></a-divider>

            <a-popover v-if="headerMore.length > 0" class="header-more-popover-container" position="br" trigger="click" :arrow-style="{ display: 'none' }" content-class="header-more-popover" :popup-visible="morePopoverVisible">
                <div :class="[
                        'header-file-more',
                        isReadOnly ? 'header-file-more-readonly' : ''
                    ]" @click="headerFileMoreClick">
                    <svg-icon class="file-more" name="header-file_more"></svg-icon>
                </div>
                <template #content>
                    <div class="more-popover" ref="morePopRef">
                        <template v-for="item in headerMore" :key="item.id">
                            <FileOperateBtn v-if="item.id === 'operation&visit'" @onselectionchange="fileInfoPopUpAction">
                                <div class="more-item">
                                    <div class="left">
                                        <svg-icon :name="item.icon" class="more-icon"></svg-icon>
                                        <div class="more-item-name">
                                            {{ item.name }}
                                        </div>
                                    </div>
                                    <svg-icon v-if="item.isMore" name="dir-back" class="more-icon-right"></svg-icon>
                                </div>
                            </FileOperateBtn>
                            <div v-else class="more-item" @click.stop="clickMoreOptions(item)">
                                <div class="left">
                                    <svg-icon :name="item.icon" class="more-icon"></svg-icon>
                                    <div class="more-item-name">
                                        {{ item.name }}
                                    </div>
                                </div>
                                <svg-icon v-if="item.isMore" name="dir-back" class="more-icon-right"></svg-icon>
                            </div>
                        </template>
                    </div>
                </template>
            </a-popover>
            <RateButton v-if="!isSourceFromHome"></RateButton>
            <a-divider direction="vertical" v-if="showtype !== 'sdk' && !isInToca && !isSourceFromHome"></a-divider>
            <EditHeadLogoutPopup v-if="showtype !== 'sdk' && !isSourceFromHome && !isInToca"></EditHeadLogoutPopup>

            <openPopper v-if="isSourceFromHome"></openPopper>
            <a-divider direction="vertical" v-if="isSourceFromHome"></a-divider>
            <closePopper v-if="isSourceFromHome"></closePopper>

            <a-modal class="file-transfer-dialog" v-model:visible="showTransferDialog" :simple="true" :footer="false" :mask-closable="false" :esc-to-close="false" :unmount-on-close="true">
                <TransferView v-if="showTransferDialog" :fileId="fileId" @closeTransferDialog="closeTransferDialog"></TransferView>
            </a-modal>
        </div>
    </div>
</template>

<script lang="ts">
import { intl } from 'tci18n-vue3'
import { HocuspocusModule } from '../../store/types';

import { mapActions, mapState, mapGetters } from 'vuex';

import { clearCookieAndToLogin } from '../../login';
import FileShareView from '../share/FileShareView.vue';

import EditHeadLogoutPopup from './EditHeadLogoutPopup.vue';
import { getBrowser } from '../../utils/browser';
import {
getFileSettings,
kbStarFile,
queryFilePath,
convertTemplate,
saveToMineTemplate,
getFileOperateRecords,
getFileViewRecord } from
'../../core/api/file';
import {
exportPdfAPI } from
'../../core/api/export';
import { getExportPollingQueue } from '../../core/utils/exportPolling';
import { nextTick } from 'vue';
import TransferView from '../transfer/TransferView.vue';
import FileShareScopeView from '../share/FileShareScopeView.vue';

import AuthHead from './auth.vue';
import BreadCrumb from '../otherview/breadcrumb/BreadCrumb.vue';
import BreadcrumbItem from '../otherview/breadcrumb/BreadCrumbItem.vue';
import BreadCrumbDropList from '../otherview/breadcrumb/BreadCrumbDropList.vue';
import { debounce } from '@/utils/lodash';
import { store } from '@/store/store';
import RecentFileEntrance from '../kbdir/FileRecent/RecentFileEntrance.vue';
import closePopper from '../otherview/head/closePopper.vue';
import openPopper from '../otherview/head/openPopper.vue';
import resources from '../../utils/resources';
import TemplateTrans from "./TemplateTrans.vue";
import { Modal } from '@toca/arco-design-web-vue';
import { setSaviorConfigure, updateSaviorData } from '../../utils/savior';
import { TocaWikiFileInoPopup, TocaWikiCheckReminder, TocaWikiPreferenceSetting, TocaWikiLinkShareRangeSet } from '@toca/toca-wiki-template';
import '@toca/toca-wiki-template/dist/style.css';
import RateButton from './rate_button.vue';
import FileOperateBtn from '../setting/FileOperatBtn.vue';
import { onClickOutside } from '@vueuse/core';
import { ref } from 'vue';

interface StatesArray {
  user?: {
    color?: String;
    name?: String;
    avatar: string;
    userId: String;};}



export default {
  name: 'edit_head',
  props: {
    awareness: { type: Array<StatesArray>, default: [] } },

  emits: ['gotoRoute', 'deleteFile', 'updateTemplateType', 'moveFile', 'createCopy'],
  components: {
    FileShareView,
    EditHeadLogoutPopup,
    TransferView,
    AuthHead,
    FileShareScopeView,
    BreadCrumb,
    BreadcrumbItem,
    BreadCrumbDropList,
    RecentFileEntrance,
    closePopper,
    openPopper,
    TemplateTrans,
    RateButton,
    FileOperateBtn },

  setup(props, context) {
    const morePopRef = ref(null);
    let morePopoverVisible = ref(false);
    onClickOutside(morePopRef, (event) => {
      morePopoverVisible.value = false;
    });

    return {
      morePopRef,
      morePopoverVisible: morePopoverVisible };

  },
  data() {
    return {
      firstFileState: true,
      isNew: false,
      showShare: false,
      trigerTargetRef: 'trigerTargetRef',
      isTitleEditing: false,
      isTitleHovered: false,
      auth: '',
      fileId: '',
      sameSpace: false,
      creator: '',
      creatorInfo: {},
      _allAwareness: new Array<StatesArray>(),
      _title_input_width: 20.0,
      settingsValue: 'PREVIEW',
      isDirExpandTipShow: false,
      preview_or_edit_btn_mouse_state: false,
      showTransferDialog: false,
      showShareScope: false,
      breadMoreIconHovered: false,
      breadcrumbWidthObserver: null,
      breadCrumbContainerWidth: 0,
      routeItems: [],
      showRouteItems: [],
      isTemplate: false,
      fileInoPopup: undefined,
      debounceTimeout: null,
      showShareScopeTip: false,
      showShareTip: false,
      checkMinder: null,
      preferenceSetting: null,
      debounceKBStar: null,
      loadCheckReminderTimer: null,
      authInfos: [],
      linkShareRangeSet: null,
      canUpdateUrlAuth: false };

  },
  watch: {
    isNewCreate: {
      handler(val) {
        if (val) {
          this.isNew = val;
        }
      },
      immediate: true },

    canUpdateUrlAuth: {
      handler(val) {
        if (this.linkShareRangeSet) {
          this.linkShareRangeSet.UpdateLinkShareRangeSet(val);
        }
      },
      immediate: true },

    doc_info: {
      handler(val) {
        if (val) {
          const isFidChanged = this.fileId !== val?.fileInfo?.fileId;
          this.auth = val.auth;
          this.fileId = val.fileInfo?.fileId;
          this.creator = val.fileInfo?.creator;
          this.creatorInfo = val.fileInfo?.creatorInfo;
          const cookiesSpaceId: string = this.spaceId;
          const currentSpaceId: string = val.fileInfo?.spaceId;
          this.sameSpace = cookiesSpaceId === currentSpaceId;
          this.$store.state.hocuspocusModule.documentTitle =
          val.fileInfo?.fileName;
          nextTick(() =>
          this.onInputingAction(val.fileInfo?.fileName));

          // 延时再检查一次
          setTimeout(
          () => this.onInputingAction(val.fileInfo?.fileName),
          200);

          // if (isFidChanged)
          this.check_file_is_preview_or_edit_action();
        }
      },
      deep: true,
      immediate: true },

    isTitleEditing(v) {
      let inputContainerEL = document.querySelector('.a_input_container');
      let inputWrapperEL =
      inputContainerEL?.getElementsByClassName(
      'arco-input-wrapper')[
      0];
      let inputEL =
      inputWrapperEL?.getElementsByClassName('arco-input')[0];
      if (v == true) {
        inputEL?.removeEventListener(
        'mousewheel',
        this.inputMouseWheel);

      } else {
        inputEL?.addEventListener('mousewheel', this.inputMouseWheel);
      }
    },
    doc_id(val) {
      if (val) {
        if (this.showShare) {
          console.log('showShare', this.showShare);
          this.showShare = false;
        }
      }
    },
    // 当别人更新title，收到socket更新curSelectedTreeNodes时，触发更新编辑器的内部的title
    documentTitle(v) {
      this.tocaEditor?.updateDocInfo({ fileName: v });
      setTimeout(() => this.onInputingAction(v), 100);
    },
    fullScreenType(v) {
      console.log('fullScreenType', v);
      this.tocaEditor?.setEditFullWidth(v == 'UNLIMITED');
    } },

  computed: {
    ...mapState({
      doc_id: (state) => state.kbModule.doc_id,
      doc_info: (state) => state.kbEditModule.doc_info,
      doc_owner: (state) => state.kbEditModule.doc_owner,
      tocaEditor: (state) => state.kbEditModule.tocaEditor,
      documentTitle: (state) => state.hocuspocusModule.documentTitle,
      curSelectedTreeNodes: (state) =>
      state.kbTreeNodeModule.curSelectedTreeNodes,
      fullScreenType: (state) => state.kbEditModule.fullScreenType,
      userSettingMode: (state) => state.kbEditModule.userSettingMode,
      isNewCreate: (state) => state.kbEditModule.isNewCreate,
      userId: (state) => state.userModule.userId,
      spaceId: (state) => state.userModule.spaceId,
      token: (state) => state.userModule.token,
      deviceId: (state) => state.userModule.deviceId,
      userDetail: (state) => state.userModule.userDetail,
      showtype: (state) => state.kbModule.showtype,
      memberAcl: (state) => state.kbTreeNodeModule.memberAcl,
      memberUniqueId: (state) => state.userModule.userDetail.id,
      sourceFrom: (state) => state.kbModule.sourceFrom,
      wikiI18n: (state) => state.kbModule.wikiI18n,
      shareAuthTip: (state) => state.kbEditModule.shareAuthTip,
      wikiSpaceInfo: (state) => state.kbTreeNodeModule.wikiSpaceInfo }),

    ...mapGetters({
      isAdmin: 'kbTreeNodeModule/isAdmin',
      isMember: 'kbTreeNodeModule/isMember' }),

    contentType() {
      return this.doc_info?.fileInfo?.contentType || "";
    },
    moreUserCount() {
      const userCount = this._allAwareness.length - 1;
      if (userCount > 99) {
        return '+99';
      }
      return `+${userCount}`;
    },
    isReadOnly() {
      return store.state.kbModule?.wikiSpaceInfo?.wikiSpaceSettings?.readOnly === true;
    },
    isSupportEdit() {
      const readOnly = store.state.kbModule?.wikiSpaceInfo?.wikiSpaceSettings?.readOnly;
      if (readOnly === true) {
        return false;
      }
      return true;
    },
    isHasTemplateAuth() {
      if (this.auth === null || this.auth === '' || this.auth === 'READ') {
        return false;
      }
      return true;
    },
    isKBDirExpand() {
      if (this.sourceFrom === 'home' && this.isInToca === true) {
        return true;
      }
      return store.state.kbTreeNodeModule.isKBDirExpand;
    },
    isSourceFromHome() {
      return this.sourceFrom === 'home' && this.isInToca === true;
    },
    inputFontWeight() {
      return this.routeItems.length > 0 ? '500' : '600';
    },
    breadMoreIconName() {
      if (this.breadMoreIconHovered === false) {
        return 'header-bread_more';
      }
      return 'header-bread_more_active';
    },
    headerMore() {
      let res = [{
        name: intl.$t("演示模式"),
        id: 'tocaeditor-fullscreen',
        icon: 'header-fullscreen' }];

      // 导出放在最前面
      if (this.auth != 'READ') {
        res.push({
          name: intl.$t("下载为PDF"),
          id: 'export-pdf',
          icon: 'header-file_pdf' });

      }

      if (this.isHistory) {
        res.push({
          name: intl.$t("历史记录"),
          id: 'history',
          icon: 'header-history' });

      }

      //模板转换or保存 (阅读及下载 以上权限)
      if (this.auth !== null && this.auth !== undefined && this.auth !== '' && this.auth !== 'READ') {
        let isCreator = this.isCreator(
        this.doc_info?.fileInfo?.creatorInfo,
        this.currentUserParams);

        if (isCreator === true) {//自己的文章，可以转换为模板
          const templateType = this.doc_info.fileInfo?.templateType;
          const iconName = 'header-template_brand_gray';
          const templateTitle = templateType === 0 ? intl.$t("转换为模板") : intl.$t("取消模板");
          res.push({
            name: templateTitle,
            id: 'transToTemplate',
            icon: iconName
            //isSwitch: true
          });
        } else
        {//别人的文章，可以保存
          res.push({
            name: intl.$t("保存为我的模板"),
            id: 'saveToTemplate',
            icon: 'header-template_brand_gray' });

        }
      }

      if (
      this.auth == 'ALL' ||
      this.doc_info.fileInfo.creatorInfo.id == this.userDetail.id &&
      this.auth == 'WRITE')
      {
        res.push({
          name: intl.$t("移动到"),
          id: 'move-to',
          icon: 'common-move' });

      }
      if (
      this.auth == 'ALL' ||
      this.auth == 'READ_DOWNLOAD' ||
      this.auth == 'WRITE')
      {
        res.push({
          name: intl.$t("创建副本"),
          id: 'create-copy',
          icon: 'common-create' });

      }
      // 操作记录
      if (this.auth == 'ALL' || this.isMyDoc) {
        res.push({
          name: intl.$t("操作记录"),
          id: 'operation&visit',
          icon: 'header-file_operate',
          isMore: true });

      }
      if (this.isTransfer) {
        res.push({
          name: intl.$t("转移所有权"),
          id: 'transfer',
          icon: 'header-file_transfer' });

      }
      if (this.auth !== null && this.auth !== 'ALL') {
        res.push({
          name: intl.$t("申请更多权限"),
          id: 'apply-auth',
          icon: 'dir-dir_unlock' });

      }

      res.push({
        name: intl.$t("设置"),
        id: 'setting',
        icon: 'dir-setting',
        isMore: true });


      if (
      this.isAdmin && this.memberAcl.canDelete == true ||
      this.isMember &&
      this.memberAcl.canDelete == true &&
      this.doc_info.auth == 'ALL' ||
      this.doc_info?.fileInfo?.creator?.id == this.memberUniqueId &&
      this.doc_info.auth == 'WRITE' &&
      this.memberAcl.canDelete == true)
      {
        res.push({
          name: intl.$t("删除"),
          id: 'delete',
          icon: 'dir-dir_delete' });

      }

      if (this.isSourceFromHome) {
        res.pop();
      }

      return res;
    },

    isTransfer() {
      const currentUserId = this.currentUserParams.userId;
      const fileUserId = this.doc_info?.fileInfo?.creatorInfo.userId;
      return currentUserId === fileUserId;
    },
    isCreator() {
      return (creatorInfo, userInfo) => {
        return (
          creatorInfo &&
          creatorInfo.userId == userInfo.userId &&
          creatorInfo.spaceId == userInfo.spaceId);

      };
    },
    isMyDoc() {
      const ownerInfo = this.doc_owner;
      return ownerInfo.userId === this.currentUserParams.userId && ownerInfo.spaceId === this.currentUserParams.spaceId;
    },
    isHistory() {
      console.log(
      'this.doc_info?.auththis.doc_info?.auth',
      this.doc_info?.auth);

      //阅读以上权限
      return this.doc_info?.auth !== 'NONE';
    },
    isMobile() {
      return getBrowser().isMobile;
    },
    isInToca() {
      return getBrowser().isInTocaApp;
    },
    starIconName() {
      if (this.curSelectedTreeNodes?.star === true) {
        return 'header-file_star';
      }
      return 'header-file_unstar';
    },
    starTip() {
      if (this.curSelectedTreeNodes?.star === true) {
        return intl.$t("取消收藏");
      }
      return intl.$t("收藏");
    },
    get_preview_or_edit_btn_icon_name() {
      if (this.isSupportEdit === false) {
        return 'dir-edit_icon';
      }
      if (this.settingsValue === 'PREVIEW') {
        if (this.preview_or_edit_btn_mouse_state)
        return 'dir-edit_icon_light';
        return 'dir-edit_icon';
      } else {
        if (this.preview_or_edit_btn_mouse_state)
        return 'dir-eye_icon_light';
        return 'dir-eye_icon';
      }
    },
    authIsReadonly() {
      return !(
      this.doc_info?.auth === 'WRITE' || this.doc_info?.auth === 'ALL');

    },
    isInTocaApp() {
      return getBrowser().isInTocaApp;
    },
    currentUserParams() {
      return { spaceId: this.spaceId, userId: this.userId };
    },
    filterAwareness() {
      // 过滤掉自己
      const userList: Array<StatesArray> = this.awareness?.filter((item) => item.user?.userId !== this.userId) ?? [];
      let result: Array<StatesArray> = [];
      userList.forEach((item) => {
        if (item.user?.userId) {
          const isExist = result.findIndex((i) => i.user?.userId === item.user?.userId);
          if (isExist === -1) {
            result.push(item);
          }
        }
      });
      this._allAwareness = result;
      if (this._allAwareness.length > 1) {
        return this._allAwareness.slice(0, 1);
      }
      return this._allAwareness;
    },
    memberName() {
      return this.userDetail?.memberName ?? 'N';
    },
    memberAvatar() {
      const str = (this.userDetail?.memberAvatar as string);
      if (str.startsWith('http')) {
        return str;
      } else {
        if (str == null || str === 'undefined') return undefined;
        return JSON.parse(str)['100'];
      }
    },
    hideRouteItems() {
      let hideItems = [];
      let showItemIds = [];
      for (let i = 0; i < this.showRouteItems.length; i++) {
        let item = this.showRouteItems[i];
        if (item.placeholder === false) {
          showItemIds.push(item.fileId);
        }
      }
      hideItems = this.routeItems.filter((item) => {
        return !showItemIds.includes(item.fileId);
      });
      return hideItems;
    } },

  mounted() {
    this.mountLinkShareRangeSet();
    this.getServeFileSettings();
    if (this.doc_id && this.doc_id.length > 0) {
      this.queryFilePath();
    }

    this.updateTemplateType();

    let inputContainerEL = document.querySelector('.a_input_container');
    let inputWrapperEL =
    inputContainerEL?.getElementsByClassName('arco-input-wrapper')[0];
    let inputEL = inputWrapperEL?.getElementsByClassName('arco-input')[0];
    inputEL?.addEventListener('mousewheel', this.inputMouseWheel);
    //初始化页面ScreenType
    this.fileInoPopup = new TocaWikiFileInoPopup("#wiki_file_ino_popup", {
      fetchData: async (since, size, scene) => {
        if (scene === 'VISIT') {
          return (await getFileViewRecord(this.fileId, since, size))?.data;
        }
        return (await getFileOperateRecords(this.fileId, since, size, scene))?.data;
      },
      locale: this.wikiI18n });

    this.debounceKBStar = debounce(this.requestKBStarFile, 500);
  },
  unmounted() {
    this.isNew = false;
    this.removeObserveBreadCrumbWidth();
    this.fileInoPopup?.destroy();
    if (this.loadCheckReminderTimer) {
      clearTimeout(this.loadCheckReminderTimer);
      this.loadCheckReminderTimer = null;
    }
    if (this.checkMinder) {
      this.checkMinder.destroy();
      this.checkMinder = null;
    }
    if (this.linkShareRangeSet) {
      this.linkShareRangeSet.destroy();
      this.linkShareRangeSet = null;
    }
  },
  methods: {
    ...mapActions({
      updateDocTitle: `${HocuspocusModule.moduleSpaceName}${HocuspocusModule.UPDATE_DOC_TITLE_ACTION}`,
      updateSelectDocName: `kbTreeNodeModule/updateSelectDocName`,
      setKBDirExpand: 'kbTreeNodeModule/setKBDirExpand',
      setCurSelectedTreeNodes: 'kbTreeNodeModule/setCurSelectedTreeNodes',
      setDocView: 'kbModule/setDocView',
      setDocInfo: 'kbEditModule/setDocInfo',
      setApplyDialog: 'kbTreeNodeModule/setApplyDialog',
      setFullScreenType: 'kbEditModule/setFullScreenType',
      setShowSetting: 'kbEditModule/setShowSetting',
      setUserSettingMode: 'kbEditModule/setUserSettingMode',
      setIsCanEdit: 'kbEditModule/setIsCanEdit',
      setIsNewCreate: 'kbEditModule/setIsNewCreate',

      setShareAuthTip: 'kbEditModule/setShareAuthTip' }),

    updateAuthInfos(authInfos) {
      this.authInfos = authInfos;
    },
    updateLinkShareInfo(auth, scope, fileId) {
      if (this.linkShareRangeSet) {
        this.linkShareRangeSet.updateShareRangeInfo(auth, scope, null, '', {
          spaceId: this.wikiSpaceInfo?.id,
          spaceName: this.wikiSpaceInfo?.spaceName });

      }
      if (this.$refs.fileShareViewRef) {
        (this.$refs.fileShareViewRef as any).updateShareInfo(auth, scope, fileId);
      }
      if (this.$refs.fileShareScopeViewRef) {
        (this.$refs.fileShareScopeViewRef as any).updateShareInfo(auth, scope, fileId);
      }
    },
    updateLinkShareRange(auth, scope, expireDate, password, spaceInfo, shareAuthTip) {
      // 统一收口
      if (this.linkShareRangeSet) {
        this.linkShareRangeSet.updateShareRangeInfo(auth, scope, expireDate, password, spaceInfo);
      }
      // 修改分享按钮提示文案
      this.setShareAuthTip(shareAuthTip);
    },
    mountLinkShareRangeSet() {
      const cookies = {
        token: store.state.userModule.token,
        spaceId: store.state.userModule.spaceId,
        userId: store.state.userModule.userId,
        deviceId: store.state.userModule.deviceId,
        memberUniqueId: store.state.userModule.userDetail?.id,
        memberId: store.state.userModule.userDetail?.id };

      this.linkShareRangeSet = new TocaWikiLinkShareRangeSet('#link_share_range_set', {
        locale: this.wikiI18n,
        env: import.meta.env.MODE,
        userInfo: cookies,
        onlyShowAuthDesc: true,
        isWiki: true,
        fileId: this.fileId,
        canUpdateLinkShareRange: this.canUpdateUrlAuth,
        shareAuth: '',
        shareScope: '',
        shareExpireDate: null,
        sharePassword: '',
        spaceInfo: {
          spaceId: '0583d',
          spaceName: intl.$t("同程旅行") },

        onUpdateShareRange: (auth, scope, expireDate, password, spaceInfo, shareAuthTip) => {
          console.log('V------------------------link_share_range_set_head-----------------');
          this.updateLinkShareRange(auth, scope, expireDate, password, spaceInfo, shareAuthTip);
        },
        onUpdateShareAuthTip: (tip) => {
          this.setShareAuthTip(tip);
        },
        onLinkRangeSetDropdownVisible: this.onLinkRangeSetDropdownVisible });

    },
    UpdateLinkShareRangeSet(canUpdate) {
      this.canUpdateUrlAuth = canUpdate;
    },
    onLinkRangeSetDropdownVisible(domId, visible) {
      if (domId === '#link_share_range_set' && visible === true) {
        this.showShare = false;
        this.showShareScope = false;
      }
    },
    clickShareScope() {
      this.showShareScope = !this.showShareScope;
      this.showShare = false;
      this.showShareScopeTip = false;
      setSaviorConfigure({
        expandfield: {
          source: "docs",
          fid: this.fileId } });


      updateSaviorData({
        eventtype: "click",
        category: "cloud_document",
        label: "share",
        eventid: "cloud_document_operation" });

      setSaviorConfigure({ expandfield: {} });
    },
    clickCheckReminder() {
      setSaviorConfigure({
        expandfield: {
          source: "docs" } });


      updateSaviorData({
        eventtype: "click",
        category: "cloud_document",
        label: "reminder",
        eventid: "cloud_document_operation" });

      setSaviorConfigure({ expandfield: {} });
    },
    shareScopeMouseEnter() {
      if (!this.showShareScope) {
        this.showShareScopeTip = true;
      }
    },
    sharMouseEnter() {
      if (!this.showShare) {
        this.showShareTip = true;
      }
    },
    headerFileMoreClick() {
      if (this.isReadOnly) {
        this.morePopoverVisible = false;
        return;
      }
      this.morePopoverVisible = true;
      this.handleCloseShareScopeView();
      this.handleCloseShareView();
    },
    fileInfoPopUpAction(index: number) {
      this.morePopoverVisible = false;
      this.fileInoPopup?.setPopupVisible(true, index);
    },
    getAssetURL(imgPath) {
      return resources.getDynamicImage(`/assets/kb_dir/${imgPath}`);
    },
    onHeaderContainerClick() {
      const editor = this.tocaEditor.editor;
      if (!editor) return;
      const selection = editor.state?.selection;
      if (!selection || selection.empty) return;
      editor.commands?.setTextSelection(0);
    },
    gotoRoute(item: any) {
      if (item.placeholder) return;
      let toUrl = item.to;
      console.log('-----------------------面包屑地址：', item);
      this.$emit('gotoRoute', item);
    },
    computeFontSize(text: any) {
      const dom = document.createElement('span');
      dom.style.fontSize = '12px';
      dom.style.opacity = '0';
      dom.style.position = 'fixed';
      dom.innerText = text;
      document.body.append(dom);
      const width = dom.offsetWidth;
      dom.remove();
      return width;
    },
    getSelectItemWidth(items: any) {
      let width = 0;
      for (let i = 0; i < items.length; i++) {
        let text = items[i].placeholder ? '...' : items[i].fileName;
        if (i == 0) {
          text = items[i].fileName;
        }
        width += this.computeFontSize(text);
      }
      if (items.length > 1) {
        let crumbWidth = (items.length - 1) * 26;
        width += crumbWidth;
      }
      return width;
    },
    computeSelectItems(items: any): any {
      let safety = 0;
      while (safety < 50) {
        const width = this.getSelectItemWidth(items);
        if (width <= this.breadCrumbContainerWidth) return items;

        const snapshot = items.
        map((item) => `${item.fileName}|${item.placeholder ? 1 : 0}`).
        join('@@');

        if (items.length === 1) {
          //一个item，后边显示省略号
          let length = items[0].fileName.length;
          items[0].fileName =
          items[0].fileName.substr(0, length - 4) + '...';
        } else if (items.length === 2) {
          const item1W = this.getSelectItemWidth([items[1]]);
          if (item1W <= this.breadCrumbContainerWidth) {
            //最后的item宽度小于容器宽度
            const itemsW = this.getSelectItemWidth(items);
            if (itemsW <= this.breadCrumbContainerWidth) {
              return items;
            } else {
              const length = items[0].fileName.length;
              items[0].fileName =
              items[0].fileName.substr(0, length - 4) + '...';
              if (items[0].fileName === '...') {
                items[0].placeholder = true;
                const itemsW1 = this.getSelectItemWidth(items);
                if (itemsW1 < this.breadCrumbContainerWidth) {
                  return items;
                } else {
                  const length = items[1].fileName.length;
                  items[1].fileName =
                  items[1].fileName.substr(0, length - 4) +
                  '...';
                }
              }
            }
          } else {
            //最后的item宽度大于容器宽度
            items[0].placeholder = true;
            const length = items[1].fileName.length;
            items[1].fileName =
            items[1].fileName.substr(0, length - 4) + '...';
          }
        } else if (items.length >= 3) {
          // 优先保证最后一个展示全，如果最后一个展示不全，前边全部折叠
          // 如果最后一个展示全了，优先保证第一个展示全，中间折叠
          const lastItemW = this.getSelectItemWidth([
          items[items.length - 1]]);

          if (lastItemW <= this.breadCrumbContainerWidth) {
            const itemsW = this.getSelectItemWidth(items);
            if (itemsW <= this.breadCrumbContainerWidth) {
              return items;
            } else {
              let item0 = items[0];
              let lastItem = items[items.length - 1];
              let newArray = [item0, lastItem];
              let length = this.getSelectItemWidth(newArray);
              if (length <= this.breadCrumbContainerWidth) {
                let defaultW = this.computeFontSize(' ... ') + 26;
                length += defaultW;
                if (length <= this.breadCrumbContainerWidth) {
                  //收尾长度小于容器宽度，中间优先展示尾部
                  let itemsW = this.getSelectItemWidth(items);
                  if (itemsW <= this.breadCrumbContainerWidth) {
                    return items;
                  } else {
                    let item1 = items[1];
                    if (item1.placeholder === true) {
                      items.splice(1, 1);
                      let item1 = items[1];
                      item1.placeholder = true;
                    } else {
                      item1.placeholder = true;
                    }
                  }
                } else {
                  //收尾大于容器宽度，中间省略
                  items.map((item: any, index: any) => {
                    if (
                    index !== 0 &&
                    index !== items.length - 1)
                    {
                      items[index].placeholder = true;
                    }
                  });
                  const length = items[0].fileName.length;
                  items[0].fileName =
                  items[0].fileName.substr(0, length - 4) +
                  '...';
                  if (items[0].fileName === '...') {
                    items[0].placeholder = true;
                    items.splice(0, 1);
                  }
                }
              } else {
                // 尾部能展示全，首部展示不全，中间就省略
                items.map((item: any, index: any) => {
                  if (index !== 0 && index !== items.length - 1) {
                    items[index].placeholder = true;
                  }
                });
                const length = items[0].fileName.length;
                items[0].fileName =
                items[0].fileName.substr(0, length - 4) + '...';
                if (items[0].fileName === '...') {
                  items[0].placeholder = true;
                  items.splice(1, 1);
                }
              }
            }
          } else {
            items.splice(1, 1);
          }
        } else {
          return items;
        }

        const nextSnapshot = items.
        map((item) => `${item.fileName}|${item.placeholder ? 1 : 0}`).
        join('@@');
        if (snapshot === nextSnapshot) {
          return items;
        }

        safety += 1;
      }

      return items;
    },
    crumbMounted() {
      this.observeBreadCrumbWidth();
    },
    observeBreadCrumbWidth() {
      const debounceTime = 200; // 100ms 的延迟
      let breadEL = document.querySelector('.bread_crumb_container');
      let that = this;
      this.breadcrumbWidthObserver = new ResizeObserver((entries) => {
        clearTimeout(that.debounceTimeout);
        that.debounceTimeout = setTimeout(() => {
          for (let entry of entries) {
            this.breadCrumbContainerWidth = entry.contentRect.width - 16;
            let copyedRouteItems = this.routeItems.map((item) => {
              return { ...item };
            });
            this.showRouteItems =
            this.computeSelectItems(copyedRouteItems);
            // console.log(
            //     '-----------------------面包屑宽度：',
            //     this.showRouteItems
            // );
          }
        }, debounceTime);
      });
      if (breadEL && this.breadcrumbWidthObserver) {
        this.breadcrumbWidthObserver.observe(breadEL);
      }
    },
    removeObserveBreadCrumbWidth() {
      if (this.breadcrumbWidthObserver) {
        this.breadcrumbWidthObserver.disconnect();
      }
    },
    toHistory() {
      this.setDocView('history');
      console.log('跳转历史记录页面');
    },
    onInputingAction(val) {
      if (getBrowser().isMobile) return;
      if (!val) {
        this._title_input_width = 100;
        return;
      }
      const containerWidth =
      document.querySelector('.a_input_container')?.clientWidth;
      const aInput = document.querySelector('.arco-input-size-medium');
      if (!containerWidth || !window.getComputedStyle) return;

      // const innerWidth = aInput.scrollWidth + 8   // 8 = paing-left+padding-right
      const style = window.getComputedStyle(aInput);
      let div = document.createElement('div');
      div.style.visibility = 'hidden';
      div.style.position = 'absolute';
      div.style.width = 'auto';
      div.style.fontSize = style.fontSize;
      div.style.fontWeight = style.fontWeight;
      div.style.letterSpacing = style.letterSpacing;
      div.style.fontFamily = style.fontFamily;
      div.style.whiteSpace = 'nowrap';
      div.innerText = aInput['value'];
      document.body.appendChild(div);
      const textWidth = div.clientWidth;
      document.body.removeChild(div);
      // 4=input-pading 8 = inputwrap-pading
      const innerWidth = textWidth + 4 + 8 + 4;

      let tempWidth = innerWidth;
      if (tempWidth < 20.0) tempWidth = 20.0;
      if (tempWidth > containerWidth) tempWidth = containerWidth;
      this._title_input_width = tempWidth;
      if (val.trim().length > 100) this.$message.info(intl.$t("输入限制100字符"));
    },
    inputMouseWheel(event) {
      event.preventDefault();
    },
    inputDrop(event) {
      //判断拖拽的文件是图片不处理
      event.preventDefault(); // 阻止拖放
      event.stopPropagation(); // 阻止事件冒泡
    },
    inputAction() {
      document.querySelector('.arco-input-size-medium')?.blur();
      const inputStr =
      this.$store.state.hocuspocusModule.documentTitle ?? '';
      this.onInputingAction(inputStr);
      if (inputStr === this.doc_info.fileName) return;
      if (inputStr.trim().length === 0) {
        this.$message.error(intl.$t("输入标题内容为空"));
        this.$store.state.hocuspocusModule.documentTitle =
        this.doc_info?.fileInfo?.fileName ?? '';
        return;
      }
      let that = this;
      this.updateDocTitle({ title: inputStr, fid: this.doc_id }).then(
      (resp) => {
        // this.$message.info(resp.data?.code === 200 ? "修改成功" : "修改失败")
        that.doc_info.fileName = inputStr;
        that.doc_info.fileInfo.fileName = inputStr;
        that.updateSelectDocName(that.doc_info.fileInfo);
      });

    },
    handleCloseShareView(val: boolean) {
      this.showShare = val;
    },
    handleCloseShareScopeView(val: boolean) {
      this.showShareScope = val;
    },
    pushToShareView() {
      this.showShareScope = false;
      this.showShare = true;
    },
    changeToApplyAuthView(title: String) {},
    fixUsername(name?: String) {
      const userName = name ?? '';
      if (userName.length >= 3) return userName.slice(1);
      return userName;
    },
    getAvatar(avatarString: String) {
      if (avatarString === undefined || avatarString === null) {
        return '';
      }
      if (avatarString.startsWith('http')) {
        return avatarString;
      } else {
        const str = (avatarString as string);
        if (str == null || str === 'undefined') return '';
        return JSON.parse(str)[100];
      }
    },
    onLogoutClick() {
      clearCookieAndToLogin(true);
    },
    // 模式切换
    async check_file_is_preview_or_edit_action() {
      let isCreator = this.isCreator(
      this.doc_info?.fileInfo?.creatorInfo,
      this.currentUserParams);

      //新建无条件编辑模式
      if (this.isNew) {
        this.settingsValue = 'EDIT';
        this.setEditorEditState(this.settingsValue === 'EDIT');
        this.setIsNewCreate(false);
        return;
      }
      if (isCreator) {
        //获取自定义偏好设置
        getFileSettings(this.doc_id, 'FILE.WIKI_PAGE_READ_MODE').
        then((resOrigin) => {
          let res = resOrigin.data;
          if (res.code == 200) {
            if (this.firstFileState) {
              let val = res.data.settingsValue;
              this.settingsValue = val;
              // 非移动端才默认进入编辑态，移动端处非创建外默认都是阅读态
              if (this.isMobile === false) {
                // 这里需要兼容一下权限，如果是仅查看，即使是自己创建的也不行
                const canEdit = this.auth == 'ALL' || this.auth == 'WRITE';
                if (canEdit === true) {
                  this.setEditorEditState(val === 'EDIT');
                }
              }
              this.firstFileState = false;
            }
          } else {
            console.error(res.message);
          }
        }).
        catch((err) => {
          console.error(err);
        });
      } else {
        const canEdit = this.auth == 'ALL' || this.auth == 'WRITE';
        if (!canEdit) this.settingsValue = 'PREVIEW';
        this.setEditorEditState(this.settingsValue === 'EDIT');
      }
    },
    async preview_or_edit_action() {
      if (this.isSupportEdit === false) {
        return;
      }
      if (this.showShare) {
        this.handleCloseShareView(false);
      }
      this.settingsValue =
      this.settingsValue === 'PREVIEW' ? 'EDIT' : 'PREVIEW';

      if (this.settingsValue === 'PREVIEW') {
        this.$message.clear();
        this.$message.success(intl.$t("已将本文切换到阅读模式"));
      } else {
        this.$message.clear();
        this.$message.success(intl.$t("已将本文切换到编辑模式"));
      }
      this.setEditorEditState(this.settingsValue === 'EDIT');
      console.log(
      'xxxxxxxxxxxx,设置编辑状态focus',
      this.settingsValue === 'EDIT');

      this.tocaEditor?.editor?.commands?.focus(
      this.settingsValue === 'EDIT');

    },
    async setEditorEditState(canEdit: boolean) {
      if (this.isReadOnly === true) {
        this.setIsCanEdit(false);
        this.tocaEditor?.setIsCanEdit(false);
        return;
      }
      if (canEdit && this.isSupportEdit === true) {
        this.setIsCanEdit(true);
        // console.log('setIsCanEditsetIsCanEditsetIsCanEdit', true);
        this.tocaEditor?.setIsCanEdit(true);
      } else {
        this.setIsCanEdit(false);
        // console.log('setIsCanEditsetIsCanEditsetIsCanEdit', false);
        this.tocaEditor?.setIsCanEdit(false);
      }
    },
    expandDir() {
      this.isDirExpandTipShow = false;
      this.setKBDirExpand(true);
    },
    clickStar() {
      if (this.curSelectedTreeNodes?.star === true) {
        this.debounceKBStar(this.curSelectedTreeNodes.fileId, false);
      } else {
        this.debounceKBStar(this.curSelectedTreeNodes.fileId, true);
      }
    },
    async requestKBStarFile(fileId, isStar) {
      try {
        const res: any = await kbStarFile(fileId, isStar);
        const { code, data, message }: any = res.data || {};
        if (code == 200) {
          if (isStar) {
            this.$message.success(intl.$t("已添加到“收藏”"));
            this.curSelectedTreeNodes.star = true;
          } else {
            this.$message.success(intl.$t("已从“收藏”中移除"));
            this.curSelectedTreeNodes.star = false;
          }
        }
      } catch (err) {
        if (isStar) {
          this.$message.error(intl.$t("收藏失败"));
        } else {
          this.$message.error(intl.$t("取消收藏失败"));
        }
      }
    },
    clickMoreOptions(item: any) {
      this.morePopoverVisible = false;
      if (this.showShare) {
        this.handleCloseShareView(false);
      }
      const { id } = item;
      switch (id) {
        case 'transfer':
          this.showTransferDialog = true;
          break;
        case 'history':
          this.toHistory();
          break;
        case 'apply-auth':
          this.setApplyDialog(true);
          break;
        case 'setting':
          this.getServeFileSettings();
          this.setShowSetting(true);
          this.showPreferenceSetting();
          break;
        case 'move-to':
          this.$emit('moveFile', { ...this.doc_info, ...this.doc_info.fileInfo });
          break;
        case 'create-copy':
          this.$emit('createCopy', { ...this.doc_info, ...this.doc_info.fileInfo });
          break;
        case 'tocaeditor-fullscreen':
          this.tocaEditor?.requestFullScreen();
          break;
        case 'export-pdf':
          this._triggerExportPDF();
          break;
        case 'delete':
          this.$emit('deleteFile', this.fileId);
          break;
        case 'saveToTemplate':
          this.saveToTemplate();
          break;
        case 'transToTemplate':
          this.templateSwitchChange();
          break;
        default:
          break;}

    },
    // leading=true, trailing=false: fires immediately on the first click and
    // ignores subsequent clicks within 1 s, preventing duplicate export requests.
    _triggerExportPDF: debounce(function () {
      const exportFileId = this.doc_id;
      const nodeMatchesCurrent = this.curSelectedTreeNodes?.fileId === exportFileId;
      const exportFileName = (nodeMatchesCurrent ?
      this.curSelectedTreeNodes?.title || this.curSelectedTreeNodes?.fileNamePrefix :
      null) ||
      this.doc_info?.fileInfo?.fileName ||
      this.documentTitle;
      const exportUserInfo = {
        userId: this.userId,
        spaceId: this.spaceId,
        token: this.token,
        deviceId: this.deviceId };

      const exportMessage = this.$message;
      exportMessage.info({
        content: intl.$t("文件导出中，完成后可在浏览器「下载记录」中查看。"),
        duration: null,
        closable: true });

      this.tocaEditor?.saveDocument(async (result: boolean) => {
        try {
          const res: any = await exportPdfAPI(exportFileId, exportFileName, exportUserInfo, exportMessage);
          if (res.success) {
            const downloadId = res?.data?.downloadId;
            if (!downloadId) {
              exportMessage.clear();
              exportMessage.error(intl.$t("文件生成失败"));
              return;
            }
            exportMessage.clear();
            exportMessage.info({
              content: intl.$t("文件导出中，完成后可在浏览器「下载记录」中查看。"),
              duration: null,
              closable: true });

            getExportPollingQueue().enqueue({
              downloadId,
              fileName: exportFileName,
              fileId: exportFileId,
              userInfo: exportUserInfo,
              message: exportMessage });

          } else {
            exportMessage.clear();
            exportMessage.error(intl.$t("文件生成失败"));
          }
        } catch (err) {
          exportMessage.clear();
          exportMessage.error(intl.$t("文件生成失败"));
        }
      });
    }, 1000, { leading: true, trailing: false }),
    closeTransferDialog() {
      this.showTransferDialog = false;
    },
    getServeFileSettings() {
      getFileSettings(this.doc_id, 'FILE.WIKI_PAGE_WIDTH_MODE').
      then((resOrigin) => {
        let res = resOrigin.data;
        if (res.code == 200) {
          let val = res.data.settingsValue;

          this.setFullScreenType(val);
        } else {
          console.error(res.message);
        }
      }).
      catch((err) => {
        console.error(err);
      });
      //查询默认模式设置
      getFileSettings('', 'FILE.WIKI_PAGE_READ_MODE').
      then((resOrigin) => {
        let res = resOrigin.data;
        if (res.code == 200) {
          let val = res.data.settingsValue;
          this.setUserSettingMode(val);
        } else {
          console.error(res.message);
        }
      }).
      catch((err) => {
        console.error(err);
      });
    },
    async queryFilePath() {
      this.routeItems = []; //清空
      let fileId = this.doc_id;
      try {
        let res = await queryFilePath(fileId, false);
        const { code, data, message } = res.data;
        if (code === 200) {
          this.routeItems = data.map((item: any) => ({
            ...item,
            placeholder: false }));

          this.loadCheckReminder();
        } else {
          console.log('------------查询面包屑失败:', message);
          this.loadCheckReminder();
        }
      } catch (e) {
        console.log('------------查询面包屑失败:', e.message);
        this.loadCheckReminder();
      }
    },
    updateTemplateType() {
      this.isTemplate = this.doc_info?.fileInfo?.templateType !== null && this.doc_info?.fileInfo?.templateType !== 0;
      this.$emit('updateTemplateType', this.doc_info?.fileInfo?.templateType);
    },
    transTemplate() {
      this.tocaEditor?.saveDocument(
      debounce((result: boolean) => {
        console.log('-----------------result:', result);
        this.gotoTransTemplate();
      }, 1000));

    },
    gotoTransTemplate() {
      if (this.isMyDoc === true) {
        convertTemplate(this.doc_id).then((res) => {
          const { data, code } = res.data;
          if (code === 200) {
            const templateType = data;
            if (data !== 0) {
              updateSaviorData({
                eventtype: 'click',
                category: 'cloud_document',
                label: 'set_myDoc',
                eventid: 'Template_opreation',
                value: {
                  fid: this.doc_id } });


              this.$message.success(intl.$t("转换成功,可一键使用或分享"));
            }
            const newDocInfo = JSON.parse(JSON.stringify(this.doc_info));
            newDocInfo.fileInfo.templateType = templateType;
            this.setDocInfo(newDocInfo);
            this.updateTemplateType();

          } else {
            console.log('---------转换失败:', code);
            const templateType = this.doc_info.fileInfo.templateType;
            if (templateType !== 0) {
              this.$message.error(intl.$t("取消失败"));
            } else {
              this.$message.error(intl.$t("转换失败"));
            }
          }
        }).catch((err) => {
          console.log('---------转换失败:', err);
          const templateType = this.doc_info.fileInfo.templateType;
          if (templateType !== 0) {
            this.$message.error(intl.$t("取消失败"));
          } else {
            this.$message.error(intl.$t("转换失败"));
          }
        });
      } else
      {
        this.saveToTemplate();
      }
    },
    templateSwitchChange(value) {
      this.transTemplate();
    },
    saveToTemplate() {
      let that = this;
      Modal.warning({
        title: intl.$t(`确认保存为我的模板？`),
        content: intl.$t("保存后，对模板的修改不会影响当前文档，你可以在模板库＞我的模板中查看"),
        modalClass: "template_saveMe_dialog",
        bodyClass: "template_saveMe_dialog_body",
        titleAlign: "start",
        closable: false,
        hideCancel: false,
        okText: intl.$t("确定"),
        cancelText: intl.$t("取消"),
        onOk(e) {
          saveToMineTemplate(that.doc_id).then((res) => {
            const { data, code, message } = res.data;
            if (code === 200) {

              updateSaviorData({
                eventtype: 'click',
                category: 'cloud_document',
                label: 'set_otherDoc',
                eventid: 'Template_opreation',
                value: {
                  fid: this.doc_id } });



              that.$message.success(intl.$t("保存成功"));
              const fileUrl = data.fileUrl;
              window.open(fileUrl, '_blank');
            } else {
              that.$message.error(message);
            }
          }).catch((err) => {
            that.$message.error(intl.$t("保存失败"));
          });
        } });

    },
    loadCheckReminder() {
      this.loadCheckReminderTimer = setTimeout(() => {
        try {
          const cookies = {
            token: store.state.userModule.token,
            spaceId: store.state.userModule.spaceId,
            userId: store.state.userModule.userId,
            deviceId: store.state.userModule.deviceId,
            memberUniqueId: store.state.userModule.userDetail?.id,
            memberId: store.state.userModule.userDetail?.id };

          this.checkMinder = new TocaWikiCheckReminder("#check_reminder_container", {
            locale: this.wikiI18n,
            env: import.meta.env.MODE,
            isShowAddAuth: this.auth === 'ALL' ? true : false,
            userInfo: cookies,
            fileId: this.doc_id,
            onGetDocMentionUserList: () => {
              return this.tocaEditor?.editor?.commands?.getAllMentionParagraphText();
            },
            onGetDocCollaboratorList: () => {
              const collaboratorList = this.authInfos.filter((item: any) => {
                return item.toType === "PERSON" && item.memberIdentity === 'COLLABORATOR';
              });
              return collaboratorList.map((item: any) => {
                return {
                  anchorId: '',
                  content: '',
                  spaceId: item.toSpace,
                  userId: item.to };

              });
            } });

        } catch (e) {
          console.error(intl.$t("加载提醒查阅失败:"), e);
        }
      }, 500);
    },
    showPreferenceSetting() {
      setTimeout(() => {
        const cookies = {
          token: store.state.userModule.token,
          spaceId: store.state.userModule.spaceId,
          userId: store.state.userModule.userId,
          deviceId: store.state.userModule.deviceId,
          memberUniqueId: store.state.userModule.userDetail?.id,
          memberId: store.state.userModule.userDetail?.id };

        this.preferenceSetting = new TocaWikiPreferenceSetting("#preference_setting_dialog",
        {
          locale: this.wikiI18n,
          env: import.meta.env.MODE,
          userInfo: cookies,
          fileId: this.doc_id,
          fullScreenType: this.fullScreenType,
          isWiki: true,
          userSettingMode: this.userSettingMode,
          showSettings: ['fullWidth', 'editMode'],
          onCloseDialog: () => {
            this.setShowSetting(false);
          },
          onUpdateFullScreenType: (type) => {
            this.setFullScreenType(type);
          },
          onUpdateUserSettingMode: (mode) => {
            this.setUserSettingMode(mode);
          } });

      }, 0);
    } } };
</script>

<style lang="scss">
.template_switch_checked {
    margin-right: 8px;
    min-width: 24px !important;
    width: 24px !important;
    height: 12px !important;
    background: #5c70ff !important;

    span {
        width: 10px !important;
        height: 10px !important;
        left: unset !important;
        right: 1px !important;
        top: 1px !important;
    }
}

.template_switch {
    margin-right: 8px;
    min-width: 24px !important;
    width: 24px !important;
    height: 12px !important;
    background-color: #e4e5ed !important;

    span {
        width: 10px !important;
        height: 10px !important;
        right: unset !important;
        left: 1px !important;
        top: 1px !important;
    }
}

.arco-input-wrapper {
    // overflow: hidden !important;
    padding: 0px 4px !important;

    .arco-input {
        overflow: hidden !important;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 14px;
        font-weight: v-bind(inputFontWeight);
    }
}

.arco-input-size-medium {
    padding: 4px 2px !important;
    border-color: transparent;
}

.header-more-popover-container {
    .header-more-popover {
        padding: 0;
        border: 1px solid #e6e8ec;
        box-shadow: 0 8px 12px 0 #1213171a;
        border-radius: 8px;

        .arco-popover-content {
            margin-top: 0 !important;
            display: flex;
            flex: 1;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .more-popover {
                padding: 4px;

                .more-item {
                    margin-top: 4px;
                    width: 174px;
                    height: 32px;
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    border-radius: 8px;
                    cursor: pointer;

                    .left {
                        flex: 1;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: flex-start;
                    }

                    .more-item-popover {
                        width: 140px;
                        height: 32px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: flex-start;
                    }

                    &:hover {
                        background: #f4f6f9;
                    }

                    .more-icon {
                        width: 16px;
                        height: 16px;
                        margin: 0 8px;
                    }

                    .more-icon-right {
                        width: 14px;
                        height: 14px;
                        margin-right: 8px;
                    }

                    .more-item-name {
                        font-weight: 400;
                        font-size: 14px;
                        color: #222329;
                        letter-spacing: 0;
                        line-height: 20px;
                    }
                }

                .more-item:first-child {
                    margin-top: 0 !important;
                }
            }
        }
    }
}

.file-transfer-dialog {
    z-index: 3000 !important;

    .arco-modal {
        width: 543px;
        padding: 0;
        border-radius: 16px;

        .arco-modal-header {
            display: none;
        }
    }
}
</style>

<style lang="scss" scoped>
.head_container {
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 54px;
    background-color: #ffffff;

    .foldBtnContainer {
        margin-left: 16px;
        margin-right: 0px;
        width: 26px !important;
        height: 26px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;

        .kb_dir_expand_icon {
            width: 16px;
            height: 16px;
        }
    }

    .kb_name_container {
        margin-left: 11px;
    }

    .foldBtnContainer:hover {
        background-color: #eaebec;
    }
}

.title_container {
    overflow: hidden;
    flex-grow: 1;
    height: 38px;
    display: flex;
    flex-direction: column;
    min-width: 200px; //防止看不见

    .bread_crumb_container {
        height: 17px;
        margin-top: 1px;
        padding-left: 18px;
        display: flex;
        align-items: center;

        .brand {
            margin-right: 4px;
            width: 12px;
            height: 12px;
        }

        .kb_breadcrumb {
            font-size: 12px;
            line-height: 17px;
            .active {
                color: #c1c5c5;
                font-size: 12px;
                font-weight: normal !important;
                height: 5px;
                &:hover {
                    border-radius: 4px;
                    color: #121317;
                    cursor: pointer;
                }
                &:active {
                    color: #121317;
                }

                span {
                    svg {
                        width: 16px;
                        height: 16px;
                    }
                }
            }
            .default {
                color: #121317;
                font-size: 12px;
                cursor: default !important;
                font-weight: normal !important;
            }
        }
    }
}

.a_input_container_home {
    padding-left: 0px !important;
}

.a_input_container {
    overflow: hidden;
    flex-grow: 1;
    padding-left: 12px;
    height: 20px;

    .templateMark_en {
        width: 52px !important;
        svg {
            width: 52px !important;
        }
    }

    .templateMark {
        width: 28px;
        height: 16px;
        margin-right: 6px;
        display: flex;
        align-items: center;
        svg {
            width: 28px;
            height: 16px;
        }
    }

    .head_star_icon_container {
        margin-left: -4px;
        width: 22px;
        height: 22px;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
            background-color: #f4f6f9;
            border-radius: 6px;
        }

        .head_star_icon {
            width: 14px;
            height: 14px;
        }
    }
}

.a_input_container a-input {
    text-overflow: ellipsis;
    width: 100%;
}

.head_tips {
    font-weight: 400;
    font-size: 12px;
    color: #3d4757;
    display: flex;
    align-items: center;
}

.align-items-center {
    display: flex;
    align-items: center;
}

.head_tips img {
    width: 13px;
    height: 13px;
    margin-right: 5px;
}

.tail_container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-right: 16px;

    .shareBtn {
        width: 26px;
        height: 26px;
        margin-left: 12px;
        border-radius: 4px;
        background-color: #ffffff;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        line-height: 26px;
        cursor: pointer;
        user-select: none;

        &:hover {
            background-color: #f4f6f9;
        }
    }

    .header-file-more-readonly {
        cursor: not-allowed !important;
    }

    .header-file-more {
        width: 26px;
        height: 26px;
        cursor: pointer;

        &:hover {
            background: #f4f6f9;
            border-radius: 4px;
        }

        .file-more {
            padding: 5px;
            width: 16px;
            height: 16px;
        }
    }

    .more_user_count {
        height: 26px;
        min-width: 26px;
        margin-left: 4px;
        margin-right: 0px;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &:hover {
            background-color: #F4F6F9;
        }

        .number {
            margin: 3px 4px;
            font-weight: 400;
            font-size: 14px;
            color: #323233;
        }
    }
}

.create_button {
    width: 26px;
    height: 26px;
    background: #f4f6f9;
    border-radius: 4px;
}

.more_button {
    width: 26px;
    height: 26px;
    background: #f4f6f9;
    border-radius: 4px;
}

.radius_8px {
    border-radius: 8px;
}

.radius_4px {
    border-radius: 4px;
}

.left_8px {
    margin-left: 8px;
}

.right_12px {
    margin-right: 12px;
}

.arco-input-wrapper {
    border: none;
    background-color: transparent;
}

.arco-input-wrapper:hover {
    background-color: #f4f6f9;
}

.arco-input-focus {
    border: none;
    border-color: transparent;
    background-color: #f4f6f9 !important;
}
</style>

<style lang="scss" scoped>
/* 设置滚动条的宽度 */
::-webkit-scrollbar {
    width: 5px;
}

/* 设置滚动条的背景颜色 */
::-webkit-scrollbar-track {
    background-color: transparent;
}

/* 设置滚动条的滑块样式 */
::-webkit-scrollbar-thumb {
    background-color: #dcddde;
    border-radius: 3px;
}

/* 设置滚动条滑块在 hover 状态下的样式 */
::-webkit-scrollbar-thumb:hover {
    background-color: #dcddde;
}

.insert_main_box:hover {
    background-color: transparent;
}

.insert_main_box {
    padding: 0px;
    margin: 0px;
}

.dropdown_container {
    width: 180px;
    max-height: 277px;
    overflow-y: scroll;
}

.dropdown_item {
    display: flex;
    align-content: center;
    box-sizing: border-box;
    padding: 4px 0px 4px 12px;
    border-radius: 8px;
}

.dropdown_item:hover {
    background-color: #f1f2f5;
}

.dropdown_container_img {
    width: 32px;
    height: 32px;
    border-radius: 4px;
}

.dropdown_container_name {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    padding-left: 12px;
    color: #121317;
}
</style>

<style lang="scss">
.mobile_title_container_style {
    border-bottom-color: rgba(176, 178, 188, 0.204);
    border-bottom-width: 1px;
    border-bottom-style: solid;
    padding-bottom: 0px;
}

.mobile_title_style {
    font-size: 18px;
    font-weight: 600;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: max-content;
    text-align: center;
    margin: auto;
}

.preview_or_edit_btn_disable {
    cursor: not-allowed !important;
    border: 1px solid #e8e9ee !important;
    border-radius: 4px !important;
    color: #222329 !important;

    &:hover {
        cursor: not-allowed !important;
        border: 1px solid #e8e9ee !important;
        border-radius: 4px !important;
        color: #222329 !important;
    }
}

.preview_or_edit_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 12px;
    width: 92px;
    height: 26px;
    border: 1px solid #e8e9ee;
    border-radius: 4px;
    /* text set */
    font-weight: 400;
    font-size: 14px;
    color: #222329;
    letter-spacing: 0;
    user-select: none;
}

.preview_or_edit_btn:hover {
    border: 1px solid #5c70ff;
    border-radius: 4px;
    color: #5c70ff;
    cursor: pointer;
}

.ccccccccontent {
    padding: 8px 4px 8px 8px !important;

    .dropdown_item {
        margin-bottom: 8px;
    }
}
</style>

<style lang="scss">
.kb_bread_arrow {
    display: none !important;
}
.kb_bread_popover {
    padding: 0 !important;
    background: #ffffff;
    // border: 1px solid #e6e8ec;
    box-shadow: 0 8px 12px 0 #1213171a;
    border-radius: 8px !important;
    border: none !important;

    .arco-popover-content {
        margin-top: 0px;
    }

    .btn {
        cursor: pointer;
        height: 34px;
        line-height: 34px;
        border-radius: 6px;
        padding-left: 12px;
        padding-right: 12px;
        background-color: transparent;
    }

    .disabled {
        cursor: not-allowed !important;
        color: #bec0bf;
    }
}
</style>

<style lang="scss">
.template_saveMe_dialog {
    width: 533px !important;
    // height: 160px !important;
    padding: 0px 0px 16px 0 !important;

    .arco-modal-header {
        height: 48px !important;
        border: none !important;
        padding: 24px 24px 0px 24px !important;
        line-height: 48px !important;
        text-align: end;
        margin-bottom: 8px !important;
        .arco-modal-title {
            height: 24px !important;
            font-size: 16px !important;
            font-weight: 600;
            color: #121317;
        }
    }

    .arco-modal-body {
        padding: 0px 0px !important;
    }

    .template_saveMe_dialog_body {
        font-size: 14px;
        color: #222329 !important;
        text-align: start !important;
        font-weight: 400 !important;
        margin: 0px 52px !important;
    }

    .arco-modal-footer {
        border: none !important;
        height: 36px !important;
        margin-top: 24px;
        padding: 0px 16px 0px 0px !important;
        display: flex !important;
        justify-content: flex-end;

        .arco-btn {
            margin-right: 8px;
            border-radius: 8px;
            width: 76px;
            height: 36px;
        }

        .arco-btn-primary {
            color: #fff !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            background: #5c70ff;
            border-radius: 6px;

            &:hover {
                background-color: #6d7dff !important;
            }
        }
        .arco-btn-secondary {
            background-color: #ffffff !important;
            color: #222329 !important;
            font-size: 14px !important;
            font-weight: 500 !important;
            border: 1px solid #e8e9ee;
            border-radius: 6px;

            &:hover {
                background-color: #f4f6f9 !important;
            }
        }
    }
}
</style>
